import React, { useEffect, useState } from 'react'
import ModalTest from '../../../BaseModal'
import { CloseDiv, ContainerOfModal, FormContainer, Header, HeaderTitle, InputDiv, Label, Input, ButtonContainer, Button } from '../../../styles/modal-style'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { X } from 'lucide-react'
import SelectSupplierInResource from './SelectSupplier'
import axios from 'axios'

interface CompanyItemType {
  id: number
  companyName: string
  cnpj: string
}

interface ResourceFormType {
  name: string
  type: string
  category: string
  description: string
  pricePerUnit: string
}

const CreateResourceModal = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const [selectedSuppliers, setSelectedSuppliers] = useState<CompanyItemType[]>([])
  const [formData, setFormData] = useState<ResourceFormType>({
    name: '',
    type: '',
    category: '',
    description: '',
    pricePerUnit: '',
  })

  useEffect(() => {
    const fetchData = async () => {
    if (id) {
      try {
        const response = await axios.get(`${process.env.REACT_APP_RESOURCES_BASE_URL}/resource/${id}`)
        setFormData(response.data)
        setSelectedSuppliers(response.data.suppliers)
        } catch (error) {
          console.log(error)
        }
      }
    }
    fetchData()
  }, [id])

  const handleInputChange = (field: keyof ResourceFormType, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }))
  }

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    try {
      const response = await axios.post(`${process.env.REACT_APP_RESOURCES_BASE_URL}/resource`, {
        ...formData,
        pricePerUnit: Number(formData.pricePerUnit),
        supplierIds: selectedSuppliers.map(supplier => supplier.id)
      })
      console.log(response.data)
      navigate('..')
    } catch (error) {
      console.log(error)
    }
  }
  
  return (
    <ModalTest>
      <ContainerOfModal width='850px'>
        <Header>
          <HeaderTitle>Novo Insumo</HeaderTitle>
          <CloseDiv onClick={() => navigate('..')}> <X size={20} /></CloseDiv>
        </Header>
        <FormContainer onSubmit={onSubmit} columns='1fr 1fr'>
          <InputDiv>
            <Label>Nome</Label>
            <Input 
              autoComplete='off' 
              type='text' 
              value={formData.name}
              onChange={(e) => handleInputChange('name', e.target.value)}
              placeholder="Digite o nome do insumo"
            />
          </InputDiv>

          <InputDiv>
            <Label>Categoria</Label>
            <Input 
              autoComplete='off' 
              type='text' 
              value={formData.category}
              onChange={(e) => handleInputChange('category', e.target.value)}
              placeholder="Digite a categoria"
            />
          </InputDiv>

          <InputDiv>
            <Label>Preço por Unidade</Label>
            <Input 
              autoComplete='off' 
              type='number' 
              step="0.01"
              value={formData.pricePerUnit}
              onChange={(e) => handleInputChange('pricePerUnit', e.target.value)}
              placeholder="0.00"
            />
          </InputDiv>

          <InputDiv>
            <Label>Tipo</Label>
            <Input 
              autoComplete='off' 
              type='text' 
              value={formData.type}
              onChange={(e) => handleInputChange('type', e.target.value)}
              placeholder="Digite o tipo do insumo"
            />
          </InputDiv>

          <SelectSupplierInResource suppliers={selectedSuppliers} setSuppliers={setSelectedSuppliers} />

          <InputDiv style={{ gridColumn: '1 / -1' }}>
            <Label>Descrição</Label>
            <Input 
              autoComplete='off' 
              type='text' 
              value={formData.description}
              onChange={(e) => handleInputChange('description', e.target.value)}
              placeholder="Digite a descrição do insumo"
            />
          </InputDiv>

          <ButtonContainer>
            <Button 
              type='button' 
              onClick={() => navigate('..')}
              className='cancel'
            >
              Cancelar
            </Button>
            <Button type='submit'>+ Adicionar insumo</Button>
          </ButtonContainer>
        </FormContainer>
      </ContainerOfModal>
    </ModalTest>
  )
}

export default CreateResourceModal